<!-- /* * Confidential and Proprietary. * Do not distribute without 1-800-Flowers.com, Inc. consent. *
Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved. */ -->

<a href={finalHref} {title} target="_parent" rel="noopener noreferrer">
	{#if isEmail}
		{@html emailText}
	{:else}
		<slot />
	{/if}
</a>

<script>
	export let href = '';
	export let title = '';

	const isEmail = href.startsWith('mailto:') || /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(href);

	$: finalHref = href;
	$: emailText = finalHref.replace(/^mailto:/, '');
</script>
